var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 12.0003C28 12.2655 27.8946 12.5198 27.7071 12.7074C27.5196 12.8949 27.2652 13.0003 27 13.0003H23.6175L18.895 22.4478C18.8119 22.6139 18.6841 22.7536 18.526 22.8512C18.3679 22.9488 18.1858 23.0004 18 23.0003H17.95C17.756 22.9907 17.569 22.9248 17.4119 22.8107C17.2547 22.6966 17.1342 22.5392 17.065 22.3578L9.91875 3.59526L5.91 12.414C5.83058 12.5888 5.70255 12.737 5.54118 12.8409C5.37982 12.9449 5.19195 13.0002 5 13.0003H1C0.734784 13.0003 0.48043 12.8949 0.292893 12.7074C0.105357 12.5198 0 12.2655 0 12.0003C0 11.735 0.105357 11.4807 0.292893 11.2932C0.48043 11.1056 0.734784 11.0003 1 11.0003H4.35625L9.09 0.586512C9.17161 0.406807 9.30457 0.25527 9.47214 0.150986C9.63971 0.0467029 9.83439 -0.0056626 10.0317 0.000485444C10.2289 0.00663349 10.42 0.0710201 10.5807 0.185535C10.7415 0.300051 10.8647 0.459574 10.935 0.644013L18.1238 19.519L22.105 11.5553C22.1878 11.3887 22.3154 11.2484 22.4735 11.1504C22.6316 11.0524 22.814 11.0004 23 11.0003H27C27.2652 11.0003 27.5196 11.1056 27.7071 11.2932C27.8946 11.4807 28 11.735 28 12.0003Z",
    fill: "#A38150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic1.a781fd105c22d94b949dad43b691568f.svg";
export { ForwardRef as ReactComponent };